var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dorm-attendance-v3',{attrs:{"mode":"config"}})
}
var staticRenderFns = []

export { render, staticRenderFns }